import React, { useEffect, useMemo, useState } from "react";
import { Col, Row } from "react-bootstrap";
import {
  Cell,
  LabelList,
  Pie,
  PieChart,
  ResponsiveContainer,
  Tooltip,
} from "recharts";

const data = [
  {
    name: "OPEX",
    value: 2663796660,
  },
  {
    name: "CAPES",
    value: 84000000,
  },
  {
    name: "COGS",
    value: 1991808000,
  },
  {
    name: "Other Expenses",
    value: 450401301,
  },
  {
    name: "Others",
    value: 10.25,
  },
];

const getVal = (str) => {
  return data.find((obj) => obj.name === str).value.toLocaleString();
};

const FundChart = () => {
  const [dataWithPercentage, setDataWithPercentage] = useState([]);
  const COLORS = ["#D3D3D3", "#3E3E3E", "#DC2023", "#FF6D6A"];

  const calculatePercentage = useMemo(() => {
    // Calculate total value
    const totalValue = data.reduce((acc, item) => acc + item.value, 0);

    // Calculate percentage for each item
    return data.map((item) => ({
      ...item,
      percent: (item.value / totalValue) * 100,
    }));
  }, [data]);

  useEffect(() => {
    setDataWithPercentage(calculatePercentage);
  }, [calculatePercentage]);

  const getPercent = (str) => {
    const item = dataWithPercentage.find((obj) => obj.name === str);
    if (item && item.percent) {
      return Math.floor(item.percent);
    } else {
      return 0;
    }
  };

  return (
    <>
      <Row>
        <Col md={7}>
          <ResponsiveContainer width="100%" height={400}>
            <PieChart width={730} height={300}>
              <Pie
                stroke="none"
                data={data}
                dataKey="value"
                nameKey="name"
                cx="50%"
                cy="50%"
              >
                {data.map((entry, index) => (
                  <Cell
                    key={`cell-${index}`}
                    fill={COLORS[index % COLORS.length]}
                  />
                ))}
              </Pie>
            </PieChart>
          </ResponsiveContainer>
        </Col>
        <Col md={5}>
          <div className="flex-wrap-items align-items-center pb-4">
            <div className="color-sector gray-sector"></div>
            <p className="para">
              OPEX, <br /> ${getVal("OPEX")}, <br /> {getPercent("OPEX")}%
            </p>
          </div>
          <div className="flex-wrap-items align-items-center pb-4">
            <div className="color-sector dark-sector"></div>
            <p className="para">
              CAPES, <br /> ${getVal("CAPES")}, <br /> {getPercent("CAPES")}%
            </p>
          </div>
          <div className="flex-wrap-items align-items-center pb-4">
            <div className="color-sector red-sector"></div>
            <p className="para">
              COGS, <br /> ${getVal("COGS")}, <br /> {getPercent("COGS")}%
            </p>
          </div>
          <div className="flex-wrap-items align-items-center pb-4">
            <div className="color-sector pink-sector"></div>
            <p className="para">
              Other Expenses, <br /> ${getVal("Other Expenses")}, <br />{" "}
              {getPercent("Other Expenses")}%
            </p>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default FundChart;
